import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import './cta.css';
import { useTranslation } from 'react-i18next';

const CTA = (props) => {
  const { t } = useTranslation();
  return (
    <div className='thq-section-padding'>
      <div className='thq-section-max-width'>
        <div className='cta-accent2-bg'>
          <div className='cta-accent1-bg'>
            <div className='cta-container2'>
              <div className='cta-content'>
                <span className='thq-heading-2'>
                  {props.heading1 ?? (
                    <Fragment>
                      <span className='cta-text4'>{t('cta.heading')}</span>
                    </Fragment>
                  )}
                </span>
                <p className='thq-body-large'>
                  {props.content1 ?? (
                    <Fragment>
                      <span className='cta-text6'>{t('cta.content')}</span>
                    </Fragment>
                  )}
                </p>
              </div>
              <div className='cta-actions'>
                <a
                  href='https://t.me/schengen_visa_slot_bot?start=we_03_0000'
                  target='_blank'
                  rel='noreferrer noopener'
                  className='cta-link thq-button-filled'
                >
                  <span>
                    {props.action1 ?? (
                      <Fragment>
                        <span className='cta-text5'>{t('cta.subscribe')}</span>
                      </Fragment>
                    )}
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CTA.defaultProps = {
  heading1: undefined,
  action1: undefined,
  content1: undefined,
};

CTA.propTypes = {
  heading1: PropTypes.element,
  action1: PropTypes.element,
  content1: PropTypes.element,
};

export default CTA;
